import { MglBasisAnlage } from './MglBasisAnlage';

/**
 * APIL Url: /Help/ResourceModel?modelName=MitgliedschaftAnlageYoungGeneration
 */
export class MglAnlageYoungGeneration extends MglBasisAnlage {

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MglAnlageYoungGeneration {
		return MglBasisAnlage.createFromObject(dataObject) as MglAnlageYoungGeneration;
	}
}